import {Component, OnInit, OnDestroy, DestroyRef, computed, inject, signal, Inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from "@angular/router";
import {PureOriginalResultsService} from "../../../service/PureOriginalResults.service";
import {PureOriginalService} from "../../../service/pure-original.service";
import {SearchFilterModel} from "../../../models/SearchFilter-model";
import {LocalStorageService} from "../../../service/LocalStorageService";
import {AuthService} from "../../../service/auth.service";

@Component({
    selector: 'app-requested-tunings-tables',
    templateUrl: './requested-tunings-tables.html',
    styleUrls: ['./requested-tunings-tables.css']
})
export class RequestedTuningsTables implements OnInit, OnDestroy {


    private readonly destroyRef = inject(DestroyRef);
    private disabledVersionsCheckBox = signal<string[]>([]);
    // public filtersCleared = signal<boolean>(false);

    public filterCount = signal<number>(0);
    router = inject(Router);
    route = inject(ActivatedRoute);

    pureOriginalResultsService = inject(PureOriginalResultsService);
    pureOriginalsService = inject(PureOriginalService);
    localStorageService = inject(LocalStorageService);
    public authService = inject(AuthService);
    readonly activeEcuFilter = computed(() => this.pureOriginalResultsService.selectedFilters()
        .find(filter => filter.option === 'ecuBuild' || filter.option === 'ECU_BUILD'));

    constructor(@Inject('LOCAL_MISSING_KEY') private missingFilter: string, @Inject('LOCAL_PARTIAL_KEY') private partialFilter: string) {

    }

    ngOnInit() {
        this.resetTableValue();
        this.getMostRequestedTableHeaders();
        this.getTableTypeFromRoute();
        this.loadInitialFilterCount();
    }

     loadInitialFilterCount() {
        const savedFilters = this.pureOriginalResultsService.selectedFilters();
        const activeFilterCount = this.calculateActiveFilters(savedFilters);
        this.filterCount.set(activeFilterCount);
    }

     calculateActiveFilters(filters: SearchFilterModel[]): number {
        if (!filters || filters.length === 0) return 0;
        let count = 0;
        filters.forEach(filter => {
            if (filter.option === 'hitRate') {
                if (filter.hitRateMin !== null && filter.hitRateMax !== null &&
                    filter.hitRateMin !== undefined && filter.hitRateMax !== undefined &&
                    (filter.hitRateMin !== 50 || filter.hitRateMax !== 100)) {
                    count++;
                }
            } else {
                if (filter.value && filter.value.trim() !== '') {
                    count++;
                }
            }
        });
        return count;
    }



    get filterKey(): string {
        return this.pureOriginalResultsService.type() === 'missing'
            ? this.missingFilter
            : this.partialFilter;
    }

    getTableTypeFromRoute() {
        this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
            const type = params['type'] === 'missing' ? 'missing' : 'partial';
            const fromDashboard = params['source'] === 'dashboard' || params['ecuBuild'] != null;
            let filters: SearchFilterModel[] | undefined;
            if (fromDashboard) {
                filters = [];
                try {
                    const extras = JSON.parse(params['filters'] || '[]');
                    if (Array.isArray(extras)) filters = extras.filter(filter => filter && typeof filter.option === 'string'
                        && filter.option !== 'ecuBuild' && filter.option !== 'ECU_BUILD' && typeof filter.value === 'string');
                } catch { /* Ignore an invalid optional filter list; retain the explicit ECU filter. */ }
                if (params['ecuBuild'] != null) filters.push({option: 'ecuBuild', value: params['ecuBuild']});
                const active = this.pureOriginalResultsService.displayedColumns().includes(params['sortAttribute'])
                    ? params['sortAttribute'] : 'timesRequested';
                this.pureOriginalResultsService.sortDirectionValues.set({active,
                    direction: params['sortDirection'] === 'asc' ? 'asc' : 'desc'});
            }
            this.pureOriginalResultsService.displayedTableHeaders.set([
                ...this.pureOriginalResultsService.displayedColumns(),
                ...(type === 'missing' && this.isSuperAdmin() ? ['actions'] : [])
            ]);
            this.pureOriginalResultsService.openAdvanceSettings.set(false);
            this.pureOriginalResultsService.initializeTableForType(type, filters);
            this.loadInitialFilterCount();
        });
    }

    ngOnDestroy(): void { this.pureOriginalResultsService.resetForNewType(); }

    onScroll() {
        this.pureOriginalResultsService.onScrollMostRequestedTables();
    }

    getMostRequestedTableHeaders() {
        this.pureOriginalResultsService.getMostRequestedTableHeaders();
    }

    resetTableValue() {
        this.pureOriginalResultsService.resetMostRequestedTuningsTable();
    }

    // getAllMostRequestedPartialTunings() {
    //     console.log("triggered partial");
    //     this.pureOriginalResultsService.getMostRequestedPartialTunings();
    // }
    //
    // getAllMostRequestedMissingTunings() {
    //     console.log("triggered missing")
    //     this.pureOriginalResultsService.getMostRequestedMissingTunings();
    // }

    onRowClick(event: MouseEvent, element: any) {
        const selection = window.getSelection();
        if (selection && selection.toString().trim().length > 0) {
            return;
        }
        this.openPureOriginalDetails(+element.pureOriginalBaseId);
    }

    openPureOriginalDetails(id: number) {
        this.router.navigate(['app/pure-originals/pure-original-details'], {
            queryParams: {
                pureOriginalId: id
            }
        })
    }

    backToMainTable() {
        this.pureOriginalsService.triggerBackFunction();
    }

    changeSortDirection($event: any) {
        if (this.pureOriginalResultsService.routeDriven()) {
            this.router.navigate([], {relativeTo: this.route, queryParamsHandling: 'merge',
                queryParams: {sortAttribute: $event.active, sortDirection: $event.direction}});
            return;
        }
        this.pureOriginalResultsService.sortDirectionValues.set($event);
        localStorage.setItem("sortDirectionValues", JSON.stringify($event));
        this.pureOriginalResultsService.changeSortDirection();
    }

    deleteMissingTuning(id: number, tableName: string) {
        this.pureOriginalResultsService.deleteMissingTuningFromTable(id, tableName)
    }

    changeMissingTuning(event: any, id: string, versionName: string) {
        this.disabledVersionsCheckBox().push(versionName);
        console.log(versionName, 'version name');
        let state = event.target.checked;
        this.pureOriginalsService.changeImpossibleTunings(id, state).subscribe(response => {
            console.log(response);
            this.pureOriginalsService.pureOriginalMatchingDetails.set(response);
            if (!state) {
                this.pureOriginalResultsService.mostRequestedTunings.update((tunings) =>
                    tunings.filter(tuning => tuning.id !== id)
                );
                console.log(state)
            }
        });
    }

    openAdvancedSearchSettings() {
        this.pureOriginalResultsService.openAdvancedSearchSettings();
    }



    selectFilters(filters: SearchFilterModel[]) {
        if (this.pureOriginalResultsService.routeDriven()) {
            const ecu = filters.find(filter => filter.option === 'ecuBuild' || filter.option === 'ECU_BUILD');
            const others = filters.filter(filter => filter !== ecu);
            this.router.navigate([], {relativeTo: this.route, queryParamsHandling: 'merge', queryParams: {
                source: 'dashboard', ecuBuild: ecu?.value ?? null,
                filters: others.length ? JSON.stringify(others) : null
            }});
            return;
        }
        this.updateFilterCount(this.calculateActiveFilters(filters));
        this.pureOriginalResultsService.applyFilters(filters);
    }

    removeEcuFilter(): void {
        this.selectFilters(this.pureOriginalResultsService.selectedFilters()
            .filter(filter => filter.option !== 'ecuBuild' && filter.option !== 'ECU_BUILD'));
    }

    onAdvancedSettingClosed($event: boolean) {
        this.pureOriginalResultsService.openAdvanceSettings.set($event.valueOf())
    }

    updateFilterCount(count: number) {
        this.filterCount.set(count);
    }

    isTableEmpty() {
        return this.pureOriginalResultsService.mostRequestedTunings().length === 0;
    }

    isSuperAdmin() {
        return this.authService.isSuperAdmin();
    }

    formatDate(value: any, column: string): string {
        if (value == null || value === '' || value === 'dateUploaded') return value;

        if (column === 'dateUploaded' || column === 'dateUpdated' || column === 'dateExported' || column === 'dateMatched' || column === 'versionDateUploaded') {
            const parts = value.toString().split('-');
            if (parts.length < 6) return value;

            const year = parseInt(parts[2], 10);
            const month = parseInt(parts[1], 10) - 1;
            const day = parseInt(parts[0], 10);
            const hours = parseInt(parts[3], 10);
            const minutes = parseInt(parts[4], 10);
            const seconds = parseInt(parts[5], 10);

            const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));

            if (isNaN(utcDate.getTime())) return value;

            const localDay = utcDate.getDate().toString().padStart(2, '0');
            const localMonth = (utcDate.getMonth() + 1).toString().padStart(2, '0');
            const localYear = utcDate.getFullYear();
            const localHours = utcDate.getHours().toString().padStart(2, '0');
            const localMinutes = utcDate.getMinutes().toString().padStart(2, '0');
            const localSeconds = utcDate.getSeconds().toString().padStart(2, '0');

            return `${localDay}-${localMonth}-${localYear}-${localHours}-${localMinutes}-${localSeconds}`;
        }

        return value;
    }

}
